/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationAction
 */
export interface NotificationAction {
    /**
     * 
     * @type {string}
     * @memberof NotificationAction
     */
    readonly label: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationAction
     */
    readonly url: string;
}

/**
 * Check if a given object implements the NotificationAction interface.
 */
export function instanceOfNotificationAction(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function NotificationActionFromJSON(json: any): NotificationAction {
    return NotificationActionFromJSONTyped(json, false);
}

export function NotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': json['label'],
        'url': json['url'],
    };
}

export function NotificationActionToJSON(value?: NotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

